<template>
	<div>
	</div>
</template>

<script>

export default{
	components:{
	},
    mounted(){
    },
    methods:{
	}
}

</script>